import { type API, type TRequestsHandler } from '~/utils/requestsProcessor/types';

export class TokensImpl {
  constructor(private readonly makeRequest: TRequestsHandler) {}

  /** GET /tokens */
  public getTokens(query?: {
    nft?: 'true' | 'false';
    sellable?: 'true' | 'false';
    distributable?: 'true' | 'false';
    buybackEnabled?: 'true' | 'false';
    logic?: 'or';
  }) {
    return this.makeRequest<API.TokensListResponse | undefined>(`tokens`, { method: 'GET', query });
  }

  /** GET /tokens/apr */
  public getTokensApr(query: { tokenAddress: string }) {
    return this.makeRequest<API.TokensAprResponse>(`tokens/apr`, {
      method: 'GET',
      query
    });
  }

  /** GET /tokens/{key} */
  public getTokensByKey(key: string) {
    return this.makeRequest<API.TokenByKeyResponse | undefined>(`tokens/${encodeURIComponent(String(key))}`, {
      method: 'GET'
    });
  }

  /** POST /token */
  public postToken(body: API.CreateTokenBody) {
    return this.makeRequest<API.CreateTokenResponse>(`token`, {
      method: 'POST',
      body
    });
  }

  /** PUT /token/{key} */
  public putTokenByKey(key: string, body?: API.UpdateTokenBody) {
    return this.makeRequest<API.UpdateTokenResponse>(`token/${encodeURIComponent(String(key))}`, {
      method: 'PUT',
      body: body ?? {}
    });
  }
}
